import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "text-grey text-caption ml-1"
}


export default /*@__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'AutocompleteMultiple',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createBlock(_component_v_autocomplete, _mergeProps(_ctx.$attrs, {
    "model-value": __props.modelValue,
    multiple: "",
    autocomplete: "off",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
  }), {
    selection: _withCtx(({ item, index }) => [
      (index < 2)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(index > 0 ? ', ' : '') + _toDisplayString(item.title), 1 /* TEXT */))
        : (index === 2)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "(+" + _toDisplayString((__props.modelValue?.length ?? 0) - 2) + ")", 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 16 /* FULL_PROPS */, ["model-value"]))
}
}

})